import { render, staticRenderFns } from "./AdSupported.vue?vue&type=template&id=58b23679"
import script from "./AdSupported.vue?vue&type=script&lang=js"
export * from "./AdSupported.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports